import $ from "jquery";
import _ from "underscore";
import noUiSlider from "nouislider";
import "selectize/dist/js/standalone/selectize.js";
import Select from "../components/Select";
import StateManager from "../scuba/StateManager";

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function (event, node) {
  $(node)
    .find(".js-scuba__list:has(.js-scuba__list__form)")
    .each(function (i, list) {
      new ProductsForm(list);
    });
});

/* --------------------------------------------------

    CLASS

-------------------------------------------------- */

function ProductsForm() {
  this.initialize.apply(this, arguments);
}

$.extend(ProductsForm.prototype, {
  initialize: function (list) {
    var s = this;
    this.uid = _.uniqueId("scuba-");
    this.$list = $(list);
    this.$viewport = this.$list.find(".js-scuba__list__items");

    this.$selects = this.$list.find(".js-custom-select");
    this.$price = this.$list.find(".js-price-selector").first();
    this.$prices = this.$list.find(".js-price");
    this.$minprice = this.$list.find(".js-min-price");
    this.$maxprice = this.$list.find(".js-max-price");

    $(document.body).on(
      "layout:change." + this.uid,
      $.proxy(this.invalidateLayout, this)
    );

    s.$viewport.on("itemsChanged." + s.uid, function () {
      if ($("body").hasClass("s-desktop")) {
        setTimeout(function () {
          if (s.$list.closest(".js-scuba__page").is(":last-child")) {
            s.$list.find(".c-products__item__link").first().click();
          }
        }, 200);
      }
    });

    this.$selects.each(function (i, el) {
      var select = new Select(el);
      el.selectize = select;
      // $(el).selectize({
      //   onDropdownClose: function(){
      //     $(el).closest(".c-products-form__row--input").removeClass("is-open");
      //   },
      //   onDropdownOpen: function(){
      //     $(el).closest(".c-products-form__row--input").addClass("is-open");
      //   },
      //   plugins: ['remove_button'],
      //   render: {
      //     item: (data, escape) => `<div><span class="content">${escape(data.text)}</span><span class="legend">${data.count ? escape(data.count) : 0}</span></div>`,
      //     option: (data, escape) => `<div><span class="content">${escape(data.text)}</span><span class="legend">${data.count ? escape(data.count) : 0} produit${(data.count && parseInt(data.count) > 1) ? "s" : ""}</span></div>`,
      //   },
      // });
    });
    this.$list.on("click", "[data-value]", function (e) {
      e.stopPropagation();
    });

    noUiSlider.create(this.$price.get(0), {
      start: [0, 10000],
      step: 1,
      connect: true,
      tooltips: true,
      range: {
        min: 0,
        max: 10000,
      },
      format: {
        to: function (value) {
          return parseInt(value) + "€";
        },
        from: function (value) {
          return parseInt(value);
        },
      },
    });
    var slider = this.$price.get(0).noUiSlider;
    slider.on("change", function () {
      var val = slider.get().map((i) => parseInt(i));
      if (val["0"] !== s.$minprice.val()) {
        s.$minprice.val(val["0"]);
      }
      if (val["1"] !== s.$maxprice.val()) {
        s.$maxprice.val(val["1"]);
      }
      s.$minprice.trigger("change");
    });
    this.$prices.on("change", function () {
      if (
        slider.get()["0"] !== s.$minprice.val() ||
        slider.get()["0"] !== s.$maxprice.val()
      ) {
        slider.set([s.$minprice.val(), s.$maxprice.val()]);
      }
    });

    this.$list.on("scuba:listform:refresh", function (event, data) {
      s.$selects.each(function (i, el) {
        const selectName = $(el).attr("name");
        $.each(data.facet, function (key, value) {
          if (selectName == key + "[]") {
            $.each(value, function (index, result) {
              var myIndex = index + 1;
              if (
                el.selectize.options.findIndex(function (el) {
                  return result.name === el.value;
                }) > -1
              ) {
                el.selectize.updateOption(result.name, {
                  value: result.name,
                  text: result.name,
                  count: result.count,
                  $order: myIndex,
                });
              } else {
                el.selectize.addOption({
                  value: result.name,
                  text: result.name,
                  count: result.count,
                  $order: myIndex,
                });
              }
              i++;
            });
          }
        });
      });
    });

    this.$list.one("scuba:listform:refresh", function (event, data) {
      var prices = data.facet["price"].sort(
        (a, b) => parseInt(a.name) - parseInt(b.name)
      );
      slider.updateOptions({
        range: {
          min: parseInt(prices.shift().name),
          max: parseInt(prices.pop().name),
        },
      });
    });

    this.$list
      .find(".js-scuba__list__filter")
      .on("change", function () {
        var name = $(this).attr("name");
        s.$list
          .find(`.js-scuba__list__filter__target[name=${name}]`)
          .val($(this).val())
          .trigger("change");
      })
      .trigger("change");
  },

  invalidateLayout: function (event, layout) {
    if (!layout) return;
    var s = this;
    if (layout === "HorizontalLayout") {
      s.$viewport.off("itemsChanged." + s.uid);
      s.$viewport.on("itemsChanged." + s.uid, function () {
        setTimeout(function () {
          if (s.$list.closest(".js-scuba__page").is(":last-child")) {
            s.$list.find(".c-products__item__link").first().click();
          }
        }, 200);
      });
    } else {
      s.$viewport.off("itemsChanged." + s.uid);
    }
  },
});



// WEBPACK FOOTER //
// ./scripts/components/ProductsForm.js